// ── Configuration de la promo Pentecôte ─────────────────────────────────────
// Pour désactiver la promo : passer `enabled` à `false` ou modifier endDate dans le passé.
// Pour relancer une nouvelle promo : éditer ce fichier uniquement.
// ────────────────────────────────────────────────────────────────────────────

export const promoConfig = {
  enabled: false, // ⛔️ Promo Pentecôte 2026 terminée (25 mai 2026). Réactiver en passant `enabled` à true pour une nouvelle offre.
  code: "PENTECOTE",
  title: "Offre Pentecôte",
  shortLabel: "1er cours offert",
  description: "Le premier cours est offert avec le code",
  // Fin de promo : lundi 25 mai 2026 à 23:59 heure de Paris/Luxembourg (CEST, UTC+2)
  endDate: "2026-05-25T23:59:59+02:00",
  ctaLabel: "Réclamer mon cours offert",
};

export const isPromoActive = () => {
  if (!promoConfig.enabled) return false;
  const now = Date.now();
  const end = new Date(promoConfig.endDate).getTime();
  return now < end;
};

export const getPromoTimeLeft = () => {
  const end = new Date(promoConfig.endDate).getTime();
  const now = Date.now();
  const diff = Math.max(0, end - now);
  const days = Math.floor(diff / 86400000);
  const hours = Math.floor((diff % 86400000) / 3600000);
  const minutes = Math.floor((diff % 3600000) / 60000);
  const seconds = Math.floor((diff % 60000) / 1000);
  return { diff, days, hours, minutes, seconds, expired: diff === 0 };
};
